module.exports = __webpack_public_path__ + "static/media/dashboardpage-browsefreelancerscard-avatar-1.2f91831c.webp";